import * as React from 'react'

export const SquaresArray: React.FC = () => (
  <svg width={200} height={160} viewBox="0 0 200 160" fill="none">
    <path fill="#4F4FF4" d="M160 80v80H80V80z" />
    <path fill="#fff" d="M120 40v40H80V40z" />
    <path fill="#4F4FF4" d="M80 0v80H0V0z" />
  </svg>
)
